// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emptyBlock__xUuuS {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.noResultsIcon__ELd1U {
  width: 80px;
  height: 80px;
}
.noResultsIcon__ELd1U path {
  fill: var(--tables-primary-row-icon);
}

.mainText__JpO66 {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  color: var(--tables-secondary-row-sub-title-text);
  margin-top: 20px;
}

.extraText__Db8ff {
  font-size: 11px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tables-primary-row-text-additional);
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Sensors/components/EmptyFilterBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;AA2EE;EACE,oCAAA;AAzEJ;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;EACA,eAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.emptyBlock {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.noResultsIcon {\n  width: 80px;\n  height: 80px;\n\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.mainText {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--tables-secondary-row-sub-title-text);\n  margin-top: 20px;\n}\n\n.extraText {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-additional);\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyBlock": `emptyBlock__xUuuS`,
	"noResultsIcon": `noResultsIcon__ELd1U`,
	"mainText": `mainText__JpO66`,
	"extraText": `extraText__Db8ff`
};
module.exports = ___CSS_LOADER_EXPORT___;
